	function tabs(container, elements, heading) {
	// CSS class to prevent content from beeing hidden when JS is disabled 
	document.body.className = "js-on";
	// Get articles
	var elements = container.getElementsByTagName(elements),
		// declare array that will contain links
		f = [],
		// h will be the title 
		h;

	this.active; // active one, public variable 
	this.total = elements.length; // length is a public variable too
	this.container = container;

	e = container.insertBefore(document.createElement("nav"), elements[0]), // create while inserting 
	change = function(a) { // tab change function 
		if (typeof this.active !== "undefined") f[this.active].className = elements[this.active].className = "";
		f[a].className = elements[a].className = "active";
		this.active = a;
	}, clickEvent = function(a, b) {
		a.onclick = function() {
			change(b);
			return false
		}
	};
	for (var i = 0; i < elements.length; i++) {
		f[i] = e.appendChild(document.createElement("a"));
		f[i].href = "#";
		h = [elements[i].getAttribute("data-title"), elements[i].getElementsByTagName(heading)[0]];
		f[i].innerHTML = h[0] !== null ? h[0] : h[1] ? h[1]["innerText" || "textContent"] : i + 1;
		new clickEvent(f[i], i)
	}
	change(0);

}


// prototyping to make changes easier 

tabs.prototype.change = function(a) {
	change(a - 1)
}

tabs.prototype.next = function(a) {
	active === this.total - 1 ? change(0) : change(active + 1);
}

tabs.prototype.prev = function(a) {
	active === 0 ? change(this.total - 1) : change(active - 1);
}

tabs.prototype.responsive = function(a, b) {
	nav = document.createElement("nav");
	nav.id = "mobiles";
	nav.innerHTML = "<a href=\"#\" onclick=\"" + a + ".prev(); return false\">" + b.prev + "</a><a href=\"#\" onclick=\"" + a + ".next(); return false\">" + b.next + "</a>";
	this.container.insertBefore(nav, this.container.firstChild);
	return this // returns tabs 
}